class DesktopShopNavigation extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.desktop-shop-navigation__trigger');
    this.drawer = this.querySelector('.desktop-shop-drawer');
    this.overlay = this.querySelector('[data-desktop-shop-overlay]');
    this.closeButton = this.querySelector('.desktop-shop-drawer__close');
    this.rootPanel = this.querySelector('[data-drawer-panel="root"]');
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    if (window.innerWidth >= 990) {
      if (this.drawer && this.drawer.parentElement !== document.body) {
        document.body.appendChild(this.overlay);
        document.body.appendChild(this.drawer);
      }
    }
    this.trigger?.addEventListener('click', () => this.open());
    this.overlay?.addEventListener('click', () => this.close());
    this.closeButton?.addEventListener('click', () => this.close());
    this.drawer?.querySelectorAll('[data-hover-target]').forEach((item) => {
      item.addEventListener('mouseenter', () => this.showContent(item.dataset.hoverTarget));
    });
    this.drawer?.querySelectorAll('.desktop-shop-drawer__item:not([data-hover-target])').forEach((item) => {
      item.addEventListener('mouseenter', () => this.showContent('banners'));
    });
    this.querySelectorAll('.desktop-shop-navigation__dropdown').forEach((dropdown) => {
      dropdown.addEventListener('toggle', () => this.closeOtherDropdowns(dropdown));
    });
    document.addEventListener('keyup', this.handleKeyUp);
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    document.removeEventListener('keyup', this.handleKeyUp);
    window.removeEventListener('resize', this.handleResize);
  }

  open() {
    this.setDrawerTop();
    this.classList.add('is-open');
    this.trigger?.setAttribute('aria-expanded', 'true');
    this.drawer?.setAttribute('aria-hidden', 'false');
    document.body.classList.add('desktop-shop-drawer-open');
    this.closeButton?.focus();
  }

  close() {
    if (!this.classList.contains('is-open')) return;
    this.classList.remove('is-open');
    this.trigger?.setAttribute('aria-expanded', 'false');
    this.drawer?.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('desktop-shop-drawer-open');
    
    // Reset to banners when closing
    setTimeout(() => {
      this.showContent('banners');
    }, 300);
    
    this.trigger?.focus();
  }

  showContent(contentId) {
    this.drawer?.querySelectorAll('[data-drawer-content]').forEach((item) => item.classList.remove('is-active'));
    this.drawer?.querySelectorAll('[data-hover-target]').forEach((item) => item.classList.remove('is-active'));
    
    const targetContent = this.drawer?.querySelector(`[data-drawer-content="${CSS.escape(contentId)}"]`);
    if (targetContent) targetContent.classList.add('is-active');
    
    if (contentId !== 'banners') {
      const targetItem = this.drawer?.querySelector(`[data-hover-target="${CSS.escape(contentId)}"]`);
      if (targetItem) targetItem.classList.add('is-active');
    }
  }

  setDrawerTop() {
    const top = Math.max(0, Math.round(this.getBoundingClientRect().bottom));
    this.style.setProperty('--desktop-shop-drawer-top', `${top}px`);
  }

  handleKeyUp(event) {
    if (event.code === 'Escape') {
      this.close();
      this.querySelectorAll('.desktop-shop-navigation__dropdown[open]').forEach((dropdown) => {
        dropdown.removeAttribute('open');
      });
    }
  }

  handleResize() {
    if (window.innerWidth >= 990) {
      if (this.drawer && this.drawer.parentElement !== document.body) {
        document.body.appendChild(this.overlay);
        document.body.appendChild(this.drawer);
      }
    } else {
      this.close();
      if (this.drawer && this.drawer.parentElement === document.body) {
        this.appendChild(this.overlay);
        this.appendChild(this.drawer);
      }
    }
    if (this.classList.contains('is-open')) this.setDrawerTop();
  }

  closeOtherDropdowns(activeDropdown) {
    if (!activeDropdown.open) return;
    this.querySelectorAll('.desktop-shop-navigation__dropdown[open]').forEach((dropdown) => {
      if (dropdown !== activeDropdown) dropdown.removeAttribute('open');
    });
  }
}

if (!customElements.get('desktop-shop-navigation')) {
  customElements.define('desktop-shop-navigation', DesktopShopNavigation);
}
